import { BaseModel } from "../../../../core/util/BaseModel";
import { SingleFormModel } from "../../forms/singleFormModel/SingleForm_model";
import { GetStakeholderBulkRoleFields } from "../../forms/stakeholder/BulkRoleUpdate_fields";
import { Enums } from "../../../../enums";
import LocalStorageService from "../../../../services/local/localStorageService/LocalStorageService";
import OrganisationsApi, {
  OrganisationsApi as IOrganisationsApi
} from "../../../../services/api/v2/organisations/Organisations.api";
import StakeholdersApi, {
  StakeholdersApi as IStakeholdersApi
} from "../../../../services/api/v2/stakeholders/Stakeholders.api";
import BusinessAreasApi, {
  BusinessAreasApi as IBusinessAreasApi
} from "../../../../services/api/v2/businessAreas/BusinessAreas.api";

export class BulkRoleUpdateModel extends BaseModel {
  role: FP.Entities.IRole;
  stakeholders: FP.Entities.IStakeholder[];
  stakeholderProvider: IStakeholdersApi;
  businessAreaProvider: IBusinessAreasApi;
  organisationProvider: IOrganisationsApi;
  orgId: number;
  formModel: SingleFormModel;

  /**
   *
   */
  constructor(role: FP.Entities.IRole, stakeholders: FP.Entities.IStakeholder[]) {
    super();

    this.role = role;
    this.stakeholders = stakeholders;

    this.stakeholderProvider = StakeholdersApi;
    this.businessAreaProvider = BusinessAreasApi;
    this.organisationProvider = OrganisationsApi;
    let localStorageService = LocalStorageService;
    this.orgId = parseInt(localStorageService.get(Enums.LocalCookies.ORGANISATION_ID));

    this.formModel = new SingleFormModel();
    this.formModel.formFields = GetStakeholderBulkRoleFields(
      this.stakeholders,
      this.businessAreaProvider,
      this.organisationProvider,
      this.orgId,
      role
    );
  }

  updateStakeholders = async (orgId: number): Promise<boolean> => {
    let results: Dictionary<any> = await this.formModel.submit();
    if (!results) return;
    let keys = Object.keys(results);
    let updatedStakeholders = [];

    keys.forEach(e => {
      if (e.split("-")[0] !== "label") {
        const id = e.split("-")[1];
        let stakeholder = updatedStakeholders.find(e => e["stakeholderId"] === id);
        if (stakeholder) {
          stakeholder[e.split("-")[0]] = results[e] || 0;
        } else {
          let newStakeholder = { stakeholderId: +id };
          newStakeholder[e.split("-")[0]] = results[e] || 0;
          updatedStakeholders.push(newStakeholder);
        }
      }
    });

    var updateResult = await this.stakeholderProvider.bulkUpload(orgId, updatedStakeholders);

    if (!updateResult.isError && updateResult.payload) {
      return updateResult.payload;
    }
    return false;
  };
}
